import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// services
import { OpportunityViewService } from '@app/opportunities/services/opportunity-view.service';

// utilities
import { getOpportunityIdFromRoute } from '@app/opportunities/utils';

@Injectable()
export class OpportunityManageGuardService implements CanActivate {
  constructor(
    private opportunityViewService: OpportunityViewService,
    private router: Router
  ) {}

  public canActivate(
    activeSnapshot: ActivatedRouteSnapshot,
    snapshot: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    // create a urlTree for redirecting or for grabbing opportunityId again
    const urlTree = this.router.parseUrl(
      // strip the activeSnapshot segment out of the full snapshot url
      // e.g., turning `opportunities/n/interested` into `opportunities/n`
      // (we have to remove the first forward slash in order for parseUrl
      // to correctly parse the URL)
      snapshot.url.replace(`/${activeSnapshot.routeConfig.path}`, '')
    );
    // this will return false if the user doesn't have edit permissions on
    // this particular opportunity
    return this.opportunityViewService
      .canAccessOpportunityManagement(
        getOpportunityIdFromRoute(activeSnapshot, urlTree)
      )
      .pipe(
        // redirect to overview route if no access
        map((access) => (access ? true : urlTree))
      );
  }
}
